import { UseFormRegister, FieldErrors } from "react-hook-form";
import { ActivityFormValues } from "../../zod/activitySchema";

interface TitleSectionProps {
  register: UseFormRegister<ActivityFormValues>;
  errors: FieldErrors<ActivityFormValues>;
}

export default function TitleSection({ register, errors }: TitleSectionProps) {
  return (
    <div className="flex flex-col">
      <div className="flex gap-2 items-center">
        <input
          placeholder="Nom de l'activité"
          {...register("title")}
          type="text"
          id="title"
          className="w-full p-2 rounded-md bg-input focus:outline-none focus:ring-2 focus:ring-card border border-border"
        />
      </div>
      {errors.title && (
        <p className="text-red-500 text-sm mt-1">{errors.title.message}</p>
      )}
    </div>
  );
}
